import { ObjectValuesType } from "addiction-components";

 export const USER_TYPE = {
  USER: 'User',
  APPLICATION_USER: 'ApplicationUser',
} as const;

export type UserType = ObjectValuesType<typeof USER_TYPE>;
